export default __webpack_public_path__ + "static/media/logogoogle.753020ab.svg";